import React from "react";
import { Box, FormControl, InputLabel, MenuItem, Pagination, Select, Typography } from "@mui/material";

type Props = {
  total: number;
  page: number;
  limit: number;
  onPageChange: (page: number) => void;
  onLimitChange: (limit: number) => void;
  pageSizeOptions?: number[];
  showCount?: boolean;
  showPageSizeSelector?: boolean;
};

export const PaginationFooter: React.FC<Props> = ({
  total,
  page,
  limit,
  onPageChange,
  onLimitChange,
  pageSizeOptions = [5, 10, 15, 20],
  showCount = true,
  showPageSizeSelector = true,
}) => {
  const totalPages = Math.max(1, Math.ceil((total || 0) / Math.max(1, limit)));
  const startIndex = total === 0 ? 0 : (page - 1) * limit + 1;
  const endIndex = total === 0 ? 0 : Math.min(page * limit, total);

  return (
    <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mt: 1 }}>
      <Typography variant="body2" color="text.secondary">
        {showCount ? (total === 0 ? "No results" : `Showing ${startIndex}-${endIndex} of ${total}`) : null}
      </Typography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
        {showPageSizeSelector && (
          <FormControl size="small" sx={{ minWidth: 80 }}>
            <InputLabel>Size</InputLabel>
            <Select
              value={limit}
              label="Size"
              onChange={(e) => onLimitChange(Number(e.target.value))}
              sx={{ '& .MuiSelect-select': { textAlign: 'center', paddingRight: '24px' } }}
            >
              {pageSizeOptions.map((opt) => (
                <MenuItem key={opt} value={opt} sx={{ justifyContent: 'center' }}>{opt}</MenuItem>
              ))}
            </Select>
          </FormControl>
        )}
        <Pagination
          count={totalPages}
          page={page}
          onChange={(_, p) => onPageChange(p)}
          showFirstButton
          showLastButton
        />
      </Box>
    </Box>
  );
};

export default PaginationFooter;

